export default __webpack_public_path__ + "static/media/loading-hadith.338435bb.gif";